import { render, staticRenderFns } from "./SortingCategoriesDropdown.vue?vue&type=template&id=975157cc&scoped=true"
import script from "./SortingCategoriesDropdown.vue?vue&type=script&lang=js"
export * from "./SortingCategoriesDropdown.vue?vue&type=script&lang=js"
import style0 from "./SortingCategoriesDropdown.vue?vue&type=style&index=0&id=975157cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "975157cc",
  null
  
)

/* custom blocks */
import block0 from "./translations?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fdata%2Fwww%2Fsrc%2Fcomponents%2F02-molecules%2Fsorting-categories-dropdown%2FSortingCategoriesDropdown.vue&external"
if (typeof block0 === 'function') block0(component)

export default component.exports